import { render, staticRenderFns } from "./returnLabel.vue?vue&type=template&id=a7083d1a&scoped=true&"
import script from "./returnLabel.vue?vue&type=script&lang=js&"
export * from "./returnLabel.vue?vue&type=script&lang=js&"
import style0 from "./returnLabel.vue?vue&type=style&index=0&id=a7083d1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7083d1a",
  null
  
)

export default component.exports